import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { validateShippingFields } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection/validate";
import { SHIP_TO } from "APP_ROOT/constants";

export default function validate(values) {
  return validator(values, v => {
    v
      .validate("buying_store", "company_id", "contact_id", "payment_terms")
      .satisfies(rules.required);
  });
}

export function validateShipping(values) {
  return validator(values, v => {
    validateShippingFields(SHIP_TO, values, v);
  });
}



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/ShippingDetails/validate.js